import React from 'react';
import ContainerFlex from '~/components/containerFlex';

import CardViewSelect, { IOption } from '~/components/cartViewSelect';
import AutoCompleteSelectNew from '~/components/AutoCompleteSelectNew';
import Loading from '~/components/loading';
import Input, { MaskTypes } from '~/components/input';

export interface ICamposCriteriosFiltro {
  ufOptions: IOption[];
  ufSelects: IOption[];
  cidadesOptions: IOption[];
  cidadesSelects: IOption[];
  bairrosOptions: IOption[];
  bairrosSelects: IOption[];
  statusSelects: IOption[];
  isLoading: boolean;
  limitMinDisponivel: string;
  limitMaxDisponivel: string;
}

export type TCampaingCriteriosFiltroProps = {
  formsCriteriosFiltros: ICamposCriteriosFiltro;
  setFormsCriteriosFiltros: React.Dispatch<
    React.SetStateAction<ICamposCriteriosFiltro>
  >;
  selected: IOption[];
};

const CampaingCriteriosFiltro = ({
  formsCriteriosFiltros,
  setFormsCriteriosFiltros,
  selected,
}: TCampaingCriteriosFiltroProps): JSX.Element => {
  const statusOptions: IOption[] = [
    { id: 1, value: 'ATIVO', label: 'Ativo' },
    { id: 2, value: 'INATIVO', label: 'Inativo' },
    { id: 3, value: 'INADIMPLENTE', label: 'Inadimplente' },
    { id: 4, value: 'CANCELADO', label: 'Cancelado' },
    { id: 5, value: 'COBRANCA', label: 'Cobrança' },
  ];

  return (
    <>
      <Loading status={formsCriteriosFiltros.isLoading} />
      <ContainerFlex row gap="20" wrap>
        {selected.find((item) => item.value === 'BAIRRO') && (
          <ContainerFlex
            color="#f5f5f5"
            maxWidth={50}
            padding={15}
            borderRadius={8}
            marginTop={10}
          >
            <ContainerFlex>
              <AutoCompleteSelectNew
                label="UF"
                placeholder="Selecione os estados"
                options={formsCriteriosFiltros.ufOptions}
                value={formsCriteriosFiltros.ufSelects}
                onChange={(value) =>
                  setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    ufSelects: value,
                  }))
                }
                heightWhenOpen="220px"
                showChips
                btnClear
              />
              <AutoCompleteSelectNew
                label="Cidades"
                placeholder="Selecione as cidades"
                options={formsCriteriosFiltros.cidadesOptions}
                value={formsCriteriosFiltros.cidadesSelects}
                onChange={(value) =>
                  setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    cidadesSelects: value,
                  }))
                }
                heightWhenOpen="220px"
                showChips
                btnClear
              />
              <CardViewSelect
                options={formsCriteriosFiltros.bairrosOptions}
                placeholder="Selecione opções"
                label="Bairros"
                value={formsCriteriosFiltros.bairrosSelects}
                onChange={(value) =>
                  setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    bairrosSelects: value,
                  }))
                }
                btnClear={true}
                showChips={true}
                collapsible
              />
            </ContainerFlex>
          </ContainerFlex>
        )}

        {selected.find((item) => item.value === 'STATUS_CARTAO') && (
          <ContainerFlex
            color="#f5f5f5"
            maxWidth={50}
            padding={15}
            borderRadius={8}
            marginTop={10}
          >
            <ContainerFlex>
              <CardViewSelect
                options={statusOptions}
                placeholder="Selecione opções"
                label="Status"
                value={formsCriteriosFiltros.statusSelects}
                onChange={(value) =>
                  setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    statusSelects: value,
                  }))
                }
                btnClear={true}
                showChips={true}
              />
            </ContainerFlex>
          </ContainerFlex>
        )}
      </ContainerFlex>
      {selected.find((item) => item.value === 'LIMITE_DISPONIVEL') && (
        <ContainerFlex
          color="#f5f5f5"
          padding={15}
          borderRadius={8}
          marginTop={10}
        >
          <ContainerFlex row gap="20" wrap>
            <ContainerFlex>
              <Input
                label="Limite mínimo disponível"
                placeholder="0,00"
                value={formsCriteriosFiltros.limitMinDisponivel}
                maxLength={10}
                onChange={(e) => {
                  return setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    limitMinDisponivel: e.target.value,
                  }));
                }}
                mask={MaskTypes.CURRENCY}
              />
            </ContainerFlex>

            <ContainerFlex>
              <Input
                label="Limite máximo disponível"
                placeholder="0,00"
                value={formsCriteriosFiltros.limitMaxDisponivel}
                maxLength={10}
                onChange={(e) => {
                  return setFormsCriteriosFiltros((prev) => ({
                    ...prev,
                    limitMaxDisponivel: e.target.value,
                  }));
                }}
                mask={MaskTypes.CURRENCY}
              />
            </ContainerFlex>
          </ContainerFlex>
        </ContainerFlex>
      )}
    </>
  );
};

export default CampaingCriteriosFiltro;
